import { isAccountType } from '@pulsify/shared/auth-roles'
import { createFileRoute } from '@tanstack/react-router'
import { SetPasswordFlow } from '~/features/auth/set-password-flow'
import * as m from '~/paraglide/messages'

export const Route = createFileRoute('/setup-account')({
  validateSearch: (search: Record<string, unknown>) => ({
    role: isAccountType(search.role) ? search.role : 'business',
  }),
  component: SetupAccountPage,
})

function SetupAccountPage() {
  const { role } = Route.useSearch()
  return (
    <SetPasswordFlow
      tokenType="invite"
      role={role}
      title={m.welcomeSetYourPassword()}
      description={m.setupAccountChoosePassword()}
      successTitle={m.accountSetupComplete()}
      successDescription={m.yourAccountIsReadyYouWillBeRedirectedToLogin()}
      submitIdleLabel={m.completeAccountSetup()}
      submitPendingLabel={m.settingUpAccount()}
      noTokenHelp={m.openThisPageFromYourInviteEmail()}
    />
  )
}
